const divCalendarModalFilter = {
  label: 'Filtrar por',
  closeModal: 'CANCELAR',
  done: 'APLICAR'
};

export default divCalendarModalFilter;
